import { render, staticRenderFns } from "./CardButtonForm.vue?vue&type=template&id=cb2b7fba"
import script from "./CardButtonForm.vue?vue&type=script&lang=ts"
export * from "./CardButtonForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports